// Exports
export default {
	"buttonContainer": "buttonContainer_-jvLa",
	"badge": "badge_Kl6Cf",
	"chatButton": "chatButton_12S08",
	"badgeText": "badgeText_1USrh",
	"isDisabled": "isDisabled_aMhfZ",
	"chatIcon": "chatIcon_kvT7L",
	"collapsible": "collapsible_7PuKN",
	"small": "small_n4c6W",
	"isSidebarVisible": "isSidebarVisible_0dUgP",
	"default": "default_3-goy",
	"huge": "huge_X6L3T",
	"chatText": "chatText_GzR3p"
};
